import * as THREE from 'three'
import { RIM_CENTER } from '../../constants.js'

// ============================================================================
//  prepareHoop — przygotowanie wczytanej sceny GLB do osadzenia w scenie kortu.
//  Logika CZYSTA (bez I/O): transform z katalogu, ukrycie materiałów (statyczna
//  siatka), ustawienia cieni. Wydzielona z glbHoop.js, by była testowalna w Node
//  (bez GLTFLoader/WebGL). Kontrakt zgodny z dawnym createHoop:
//  { group, rimCenter, dispose() } — Net i ShotCycle korzystają z rimCenter.
// ============================================================================

export function prepareHoop(root, hoopDef) {
  const t = hoopDef.transform || {}
  root.name = `Hoop:${hoopDef.id}`
  if (t.scale) root.scale.setScalar(t.scale)
  if (t.yaw) root.rotation.y = THREE.MathUtils.degToRad(t.yaw)
  if (t.position) root.position.fromArray(t.position)

  const hide = new Set(hoopDef.hide || [])
  root.traverse((o) => {
    if (!o.isMesh) return
    o.castShadow = true
    o.receiveShadow = true
    const name = Array.isArray(o.material) ? o.material[0]?.name : o.material?.name
    if (hide.has(name)) o.visible = false
    // Szkło nie rzuca cienia — depth pass ignoruje alfę, rzucałoby pełny prostokąt.
    // Nie odbiera też cienia: przezroczysta tafla z cieniem daje artefakty (acne)
    // i tak nie powinna na sobie pokazywać twardego cienia słońca.
    if (name === 'szyba') {
      o.castShadow = false
      o.receiveShadow = false
    }
  })

  return {
    group: root,
    rimCenter: new THREE.Vector3(RIM_CENTER.x, RIM_CENTER.y, RIM_CENTER.z),
    dispose: () => disposeGroup(root),
  }
}

// Zwalnia geometrie i materiały (materiały współdzielone — Set deduplikuje,
// każdy dispose dokładnie raz; mapy tekstur też zwalniamy).
function disposeGroup(group) {
  const materials = new Set()
  group.traverse((o) => {
    if (!o.isMesh) return
    o.geometry?.dispose()
    if (Array.isArray(o.material)) o.material.forEach((m) => materials.add(m))
    else if (o.material) materials.add(o.material)
  })
  materials.forEach((m) => {
    for (const k of ['map', 'normalMap', 'roughnessMap', 'metalnessMap', 'aoMap', 'emissiveMap']) {
      if (m[k]) m[k].dispose()
    }
    m.dispose()
  })
}
